import React from 'react';
import { Container } from './Login';

const Loaded = () => {
    return (

        <Container>
            <div className="loadingio-spinner-dual-ring-bnru7k4a7me"><div className="ldio-oj2gd664a87">
            <div></div><div><div></div></div>
            </div></div>
        </Container>

    );
};

export default Loaded;